import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'src/app/components/components.module';
import { CustomPipesModule } from 'src/app/pipes/custom-pipes.module';
import { AppRoutingModule } from '../../app.routing';
import { BlankLayoutComponent } from './blank-layout.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    AppRoutingModule,
    ComponentsModule,
    CustomPipesModule,
  ],
  declarations: [BlankLayoutComponent],
  exports: [BlankLayoutComponent],
})
export class BlankLayoutModule {}
